import { GridCellParams } from "@mui/x-data-grid";
import { useIntl } from "react-intl";
import { format, parseISO } from "date-fns";

import { AddressLink } from "@dzambalaorg/mui-scanner";
import { humanReadableDateTimeFormat } from "@dzambalaorg/constants";

// prettier-ignore
export const referralRewardColumnsCreator = (formatMessage: ReturnType<typeof useIntl>["formatMessage"]) =>  [
  {
    field: "merchant",
    headerName: formatMessage({ id: "form.labels.merchant" }),
    sortable: true,
    flex: 0.5,
  },
  {
    field: "account",
    headerName: formatMessage({ id: "form.labels.wallet" }),
    sortable: false,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} length={16} />
      );
    },
    flex: 1,
    minWidth: 100
  },
  {
    field: "event",
    headerName: formatMessage({ id: "form.labels.event" }),
    sortable: true,
    flex: 0.7,
    minWidth: 100
  },
  {
    field: "item",
    headerName: formatMessage({ id: "form.labels.item" }),
    sortable: true,
    flex: 0.7,
    minWidth: 100
  },
  {
    field: "price",
    headerName: formatMessage({ id: "form.labels.price" }),
    sortable: true,
    flex: 0.8,
    minWidth: 100
  },
  {
    field: "createdAt",
    headerName: formatMessage({ id: "form.labels.createdAt" }),
    sortable: true,
    valueFormatter: (value: string) => format(parseISO(value), humanReadableDateTimeFormat),
    flex: 1,
    minWidth: 140
  },
  {
    field: "share",
    headerName: formatMessage({ id: "form.labels.share" }),
    sortable: true,
    flex: 0.5,
    minWidth: 50
  },
  {
    field: "claim",
    headerName: formatMessage({ id: "form.labels.claimStatus" }),
    sortable: true,
    flex: 0.7,
    minWidth: 70
  },
]
